(function () {
  var STYLE_ID = 'rd-atc-shine-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '@keyframes rd-atc-bg-shift{0%{background-position:0% 50%;}100%{background-position:-220% 50%;}}' +
      '.rd-atc-shine{position:relative;overflow:hidden;isolation:isolate;z-index:0;' +
      'transition:transform 120ms ease,opacity 160ms ease;}' +
      '.rd-atc-shine:active{transform:scale(0.96);}' +
      '.rd-atc-shine.rd-atc-busy{opacity:.7;pointer-events:none;}' +
      '.rd-atc-shine::before{content:"";position:absolute;inset:0;z-index:-1;border-radius:inherit;' +
      'background:linear-gradient(100deg,#050505 0%,#050505 35%,#6b6b6b 47%,#ffffff 50%,#6b6b6b 53%,#050505 65%,#050505 100%);' +
      'background-size:260% 100%;animation:rd-atc-bg-shift 4.5s linear infinite;will-change:background-position;}' +
      '.rd-atc-shine::after{content:attr(data-rd-label);position:absolute;inset:0;display:flex;' +
      'align-items:center;justify-content:center;color:#ffffff;mix-blend-mode:difference;' +
      'font:inherit;letter-spacing:inherit;text-transform:inherit;pointer-events:none;}';
    document.head.appendChild(style);
  }

  function syncLabel(button) {
    var text = (button.textContent || '').trim();
    if (text && button.dataset.rdLabel !== text) {
      button.dataset.rdLabel = text;
    }
  }

  function applyShine(button) {
    if (button.dataset.rdAtcShineReady === 'true') return;
    button.dataset.rdAtcShineReady = 'true';

    button.classList.add('rd-atc-shine');

    button.style.setProperty('background-color', 'transparent', 'important');
    button.style.setProperty('border-color', '#050505', 'important');
    button.style.setProperty('color', 'transparent', 'important');

    syncLabel(button);

    var labelObserver = new MutationObserver(function () {
      syncLabel(button);
    });
    labelObserver.observe(button, { childList: true, characterData: true, subtree: true });
  }

  function initBusyFeedback() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

      var button = form.querySelector('[data-rd-add-to-cart].rd-atc-shine');
      if (!button || button.disabled || button.classList.contains('rd-atc-busy')) return;

      button.classList.add('rd-atc-busy');
      button.setAttribute('aria-busy', 'true');

      var cleared = false;
      function clear() {
        if (cleared) return;
        cleared = true;
        button.classList.remove('rd-atc-busy');
        button.removeAttribute('aria-busy');
      }

      var drawer = document.getElementById('verani-cart-drawer');
      if (drawer) {
        var drawerObserver = new MutationObserver(function () {
          if (drawer.getAttribute('aria-hidden') === 'false') {
            clear();
            drawerObserver.disconnect();
          }
        });
        drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
      }

      window.setTimeout(clear, 4000);
    }, true);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('[data-rd-add-to-cart]');
    if (!buttons.length) return;
    injectStyle();
    buttons.forEach(applyShine);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      initBusyFeedback();
    });
  } else {
    init(document);
    initBusyFeedback();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
